<template>
    <v-card outlined class="primary white--text">
        <div class="primary darken-1 pa-4">
            
            <div class="body-2 font-weight-medium">
                <v-icon small color="amber" left @click="$emit('cancel')">fa-arrow-left</v-icon>
                <span style="opacity:.7">My goals in {{lapse}} years</span>
            </div>
            
            <div class="ml-5">
                <div class="caption font-weight-medium" style="opacity:.7">GOAL TRACKING:</div>
                <div class="subtitle-1 mt-n1" style="opacity:.7">
                    <v-icon size="12px" color="white" class="mr-1">fa-minus</v-icon>
                    {{goal.item.goal}}
                </div>

                <div class="pl-6 my-1">
                    <v-divider></v-divider>
                </div>

                <div class="caption font-weight-medium ml-6">RESOURCE I DON´T HAVE:</div>
                <div class="title ml-7 mt-n1">
                    <v-icon size="12px" color="white" class="mr-1">fa-minus</v-icon>
                    {{goals['t'+lapse].resourcesNo['g'+this.goal.index][resource.index]}}
                </div>
            </div>
        </div>

        <v-card-text class="pt-3 px-6 pb-7 white--text" v-if="loaded">
            <div class="body-1 font-weight-medium mt-4 mb-5">
                Actions to take:
            </div>

            <div v-for="(item, index) in actions" :key="item.id">
                <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-start">
                        <div class="title mr-2">{{index+1}}.</div>
                        <div v-if="!validateIsEmpty(item.action)">
                            <div class="title font-weight-regular">{{item.action}}</div>
                            <div class="caption font-weight-regular">{{item.status}}</div>
                        </div>
                        <div v-else>
                            <div class="subtitle-1 mt-1 font-weight-medium" style="opacity:.4">PENDING...</div>
                        </div>
                    </div>
                </div>

                <v-divider class="my-4" v-if="index<actions.length-1"></v-divider>
            </div>

            <v-divider class="mt-6"></v-divider>

            <div class="mt-6 text-center">
                <v-btn outlined class="white--text" @click="$emit('edit')">
                    Edit actions to take
                </v-btn>
            </div>

            <div class="text-center mt-6 mb-3">
                <v-btn class="white primary--text" @click="$emit('cancel')">
                    <v-icon small color="primary" left>fa-angle-left</v-icon>
                    Back to goals
                </v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import Helpers from '@/services/helpers'

export default {
    data: () => ({
        loaded: false,
        actions: []
    }),
    props: ['goals', 'lapse', 'goal', 'resource'],
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let i;

            for (i=0; i<=4; i++) {
                this.actions[i] = {action:'', status:'todo'};
            }

            for (i=0; i<=4; i++) {
                if (this.goals['t'+this.lapse].resourcesNo['g'+this.goal.index+'_'+this.resource.index+'_'+i] != undefined) {
                    //this.actions[i] = this.goals['t'+this.lapse].resourcesNo['g'+this.goal.index+'_'+this.resource.index+'_'+i];
                    _.merge(this.actions[i], this.goals['t'+this.lapse].resourcesNo['g'+this.goal.index+'_'+this.resource.index+'_'+i]);
                }
            }

            this.loaded = true;
        }
    }
}
</script>